export const DEFAULT_WHATSAPP_LANGUAGE_CODE = 'en';

export const whatsappLanguageCodePattern = /^[a-z]{2,3}(?:[_-][A-Za-z]{2})?$/;

export function normalizeWhatsAppLanguageCode(languageCode: string): string {
  const [language, region] = languageCode.split(/[_-]/);
  return region ? `${language.toLowerCase()}_${region.toUpperCase()}` : language.toLowerCase();
}

export function isValidWhatsAppLanguageCode(languageCode: string): boolean {
  return whatsappLanguageCodePattern.test(languageCode);
}
